import styled from "@emotion/styled";

import { MDSIcon, MDSIconColor, MDSIconKind } from "@/mds";

export interface TranscriptSpeakerBadgeProps {
  name: string;
}

/**
 * Renders the compact speaker identity row shown before attributed voice transcript bubbles.
 */
export function TranscriptSpeakerBadge({ name }: TranscriptSpeakerBadgeProps) {
  return (
    <StyledBadge>
      <MDSIcon
        aria-hidden="true"
        kind={MDSIconKind.User}
        color={MDSIconColor.Inherit}
        size={12}
        boxSize={12}
      />
      <StyledName>{name}</StyledName>
    </StyledBadge>
  );
}

const StyledBadge = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.text.tertiary};
  display: flex;
  gap: ${({ theme }) => theme.spacing["1"]};
  justify-content: center;
  max-width: 100%;
  padding: ${({ theme }) =>
    `${theme.spacing["1"]} ${theme.spacing["1"]} ${theme.spacing["1"]} ${theme.spacing["0.5"]}`};
`;

const StyledName = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  letter-spacing: 0;
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
